// extracted by mini-css-extract-plugin
export default {"labeledInput":"LabeledInput_labeledInput__il9F5"};